import * as i0 from '@angular/core';
import { Pipe, NgModule } from '@angular/core';

const defaultTrailing = '…';
const defaultLength = 40;
class TruncateCharactersPipe {
    transform(value, ...options) {
        const limit = options[0] || defaultLength;
        let trailingString = '';
        let countTrailing = false;
        const safeValue = value || '';
        if (options && options[1] && typeof (options[1]) === 'object') {
            trailingString = options[1].trailingString || defaultTrailing;
            countTrailing = options[1].countTrailing || false;
        }
        else {
            trailingString = options[1] || defaultTrailing;
            countTrailing = options[2] || false;
        }
        let stringLength = this.getStringLength(limit, trailingString, countTrailing);
        if (stringLength < 0) {
            stringLength *= -1;
            return safeValue.length > stringLength
                ? trailingString + safeValue.substring(safeValue.length - stringLength, safeValue.length)
                : safeValue;
        }
        return safeValue.length > stringLength
            ? safeValue.substring(0, stringLength) + trailingString
            : safeValue;
    }
    getStringLength(limit, trail, countTrailing = false) {
        if (countTrailing) {
            if (limit < 0) {
                return limit + trail.length;
            }
            return limit - trail.length;
        }
        return limit;
    }
}
TruncateCharactersPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: TruncateCharactersPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
TruncateCharactersPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "14.2.3", ngImport: i0, type: TruncateCharactersPipe, name: "truncate" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: TruncateCharactersPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'truncate'
                }]
        }] });

class TruncateWordsPipe {
    transform(value, limit = 40, trail = '…') {
        let result = value || '';
        if (value) {
            const words = value.split(/\s+/);
            if (words.length > Math.abs(limit)) {
                if (limit < 0) {
                    // eslint-disable-next-line no-param-reassign
                    limit *= -1;
                    result = trail + words.slice(words.length - limit, words.length).join(' ');
                }
                else {
                    result = words.slice(0, limit).join(' ') + trail;
                }
            }
        }
        return result;
    }
}
TruncateWordsPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: TruncateWordsPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
TruncateWordsPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "14.2.3", ngImport: i0, type: TruncateWordsPipe, name: "words" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: TruncateWordsPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'words'
                }]
        }] });

const TRUNCATE_PIPES = [TruncateCharactersPipe, TruncateWordsPipe];
class TruncateModule {
}
TruncateModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: TruncateModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
TruncateModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.2.3", ngImport: i0, type: TruncateModule, declarations: [TruncateCharactersPipe, TruncateWordsPipe], exports: [TruncateCharactersPipe, TruncateWordsPipe] });
TruncateModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: TruncateModule });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: TruncateModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [TRUNCATE_PIPES],
                    exports: [TRUNCATE_PIPES]
                }]
        }] });

/*
 * Public API Surface of ng-truncate
 */

/**
 * Generated bundle index. Do not edit.
 */

export { TruncateCharactersPipe, TruncateModule, TruncateWordsPipe };
